export default [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/authentication/Login.vue"),
    meta: { title: "auth.login.page_title", requiresAuth: false },
  },
  {
    path: "/register",
    name: "Registration",
    component: () => import("@/views/authentication/Registration.vue"),
    meta: { title: "auth.register.title", requiresAuth: false },
  },
  {
    path: "/forgot_password",
    name: "ForgotPassword",
    component: () => import("@/views/authentication/password/ForgotPassword"),
    meta: { title: "auth.forgot_password.title", requiresAuth: false },
  },
  {
    path: "/reset_password/:identityId/:token",
    name: "ResetPassword",
    props: true,
    component: () => import("@/views/authentication/password/ResetPassword"),
    meta: { title: "auth.reset_password.page_title", requiresAuth: false },
  },
  {
    path: "/password_success",
    name: "SuccessPassword",
    component: () => import("@/views/authentication/password/SuccessPassword"),
    meta: { title: "auth.password_success.title", requiresAuth: false },
  },
]
